 window.Popper = require('popper.js');
 import '../../modules/system/assets/js/framework';
 import 'swiper';

 import 'bootstrap';
 import './assets/javascript/plugins/lazyload/jquery.lazyload.min';
 import './assets/javascript/plugins/lazyload/jquery.lazyloadxt.bg.min';
 import './assets/javascript/plugins/inputmask/inputmask';
 import './assets/javascript/plugins/inputmask/jquery.maskedinput';
 import './assets/javascript/plugins/parallax/jquery.paroller.min';
 import './assets/javascript/plugins/colorbox/jquery.colorbox-min';
 import './assets/javascript/plugins/modal/iziModal.min';
 import './assets/javascript/plugins/slickslider/slick.min';
 import './js/app.js';
 import './assets/javascript/plugins/timer/jquery.time-to.min';





 /* Import Libs */

 // import 'intersection-observer';
 // import '../../modules/system/assets/js/framework';
 // import './js/validation';
 // import './js/utils';
 // import './js/lazy-load';
 // import '../../node_modules/focus-visible/dist/focus-visible';

 /* * Header * */
 import './partials/header/userbar/userbar';

 /* * Drawer * */
 // import './partials/header/drawer-nav/drawer-nav';

 import './partials/product/cart/cart-mini/cart-mini';
 import './partials/product/wish-list/wish-list';

 /* * Form * */

 import './partials/form/input/input';

 /* * Other * */

 import './partials/product/product-info/product-info';
 import './partials/product/cart/cart-product/cart-product';
 import './partials/product/wish-list/wish-product/wish-product';
 import './partials/product/wish-list/wish-list';
 import './partials/product/wish-list/wish-list-add/wish-list-add';
 import './partials/common/wysiwyg/wysiwyg';
 import './partials/content/review/review-add/review-add.js';
 import './partials/content/review/review-list/review-list.js';
 import './partials/header/search/search';
 import './partials/product/catalog/filter/filter-drawer';
 import './partials/product/catalog/filter/filter-drawer';
 import './partials/product/catalog/filter-bar/filter-checked/filter-checked';
 import './partials/product/catalog/catalog-list/catalog-list';